import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import EventPage from "./Login";
import KTIG_LOGO from "./images/Tranparent-KTIG-Logo2.png";
import "./Adminpage.css";
import CONFIG from "./config";
import Swal from "sweetalert2";

const LoginForm = ({ onLogin }) => {
  const [credentials, setCredentials] = useState({
    user_name: "",
    user_password: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCredentials({ ...credentials, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${CONFIG.BASE_URL}/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(credentials),
      });

      if (response.ok) {
        const data = await response.json();
        console.log("Login Successful:", data);

        // ✅ Store JWT Token in localStorage
        localStorage.setItem("authToken", data.token);

        onLogin();
        navigate("/admin-dashboard", { state: data });
      } else {
        const errorData = await response.json();
        Swal.fire({
          title: "Login Failed",
          text: errorData.message || "Invalid credentials. Please try again.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Login error:", error);
      Swal.fire({
        title: "Error",
        text: "An error occurred while trying to log in. Please try again later.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <div className="admin_loginscreen">
      <form onSubmit={handleSubmit}>
        <div className="col-12 pt-3">
          <label style={{ display: "block" }}>
            Username:
            <input
              type="text"
              name="user_name"
              value={credentials.user_name}
              onChange={handleInputChange}
              required
              style={{ width: "100%", padding: "10px", margin: "5px 0 15px 0" }}
            />
          </label>
        </div>

        <div className="col-12">
          <label style={{ display: "block" }}>
            Password:
            <div className="input-group" id="show_hide_password">
              <input
                required
                name="user_password"
                className="form-control"
                type={showPassword ? "text" : "password"}
                value={credentials.user_password}
                onChange={handleInputChange}
              />
              <button
                type="button"
                className="input-group-text bg-transparent border-0"
                onClick={() => setShowPassword(!showPassword)}
              >
                <i
                  className={
                    showPassword ? "bi bi-eye-fill" : "bi bi-eye-slash-fill"
                  }
                ></i>
              </button>
            </div>
          </label>
        </div>

        <div className="col-12 mt-3">
          <button
            className="btn-grd-primary"
            type="submit"
            style={{
              width: "100%",
              background: "#007bff",
              color: "white",
              border: "none",
              cursor: "pointer",
            }}
          >
            Login
          </button>
        </div>
      </form>
    </div>
  );
};

const Login = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (token) {
      navigate("/admin-dashboard");
    }
  }, [navigate]);

  const handleLogin = () => {
    setIsLoggedIn(true);
  };

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    setIsLoggedIn(false);
    navigate("/login");
  };

  return (
    <div className="section-authentication-cover admin_log_wrap">
      <div className="row g-0">
        <div className="col-12 col-xl-7 col-xxl-8 auth-cover-left align-items-center justify-content-center d-xl-flex border-end bg-transparent">
          <div className="card rounded-0 mb-0 border-0 shadow-none bg-transparent bg-none">
            <div className="card-body">
              <div className="col-10 logo_login">
                <img
                  className="admin_login_logo img-fluid auth-img-cover-login"
                  src={KTIG_LOGO}
                  alt="KTIG"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="col-12 col-xl-5 col-xxl-4 auth-cover-right align-items-center justify-content-center border-4 border-primary">
          <div className="card w-100 d-block rounded-0 mb-0 border-0 shadow-none bg-none">
            <div className="card-body p-sm-5">
              <div className="admin_log_wrap mx-auto">
                <h6 className="fw-bold text-center">Welcome to</h6>
                <h3 className="fw-bold text-center">Admin Login</h3>
                {!isLoggedIn ? (
                  <LoginForm onLogin={handleLogin} />
                ) : (
                  <>
                    <EventPage />
                    <button
                      className="btn btn-danger mt-3"
                      onClick={handleLogout}
                    >
                      Logout
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
